import React from "react";

import { Text } from "@performyard/py-components";

import Spacer from "../../../../../../../components/Spacer";
import { SurveyAccessSelect } from "../components/SurveyAccessSelect";

import { EyeChecklistBrowserPlane } from "../../../../../illustrations/EyeChecklistBrowserPlane";
import { SURVEY_PARTICIPANTS_CONFIG } from "../constants";

export const AllEmployees = ({ surveyId }: { surveyId: string }) => {
	return (
		<>
			<SurveyAccessSelect selectionCount={0} surveyId={surveyId} />
			<Spacer height={2} />
			<div
				className={`flex h-[${SURVEY_PARTICIPANTS_CONFIG.UI_CONFIG.PLACEHOLDER_HEIGHT}] w-full flex-col items-center justify-center gap-4 border border-solid border-neutral-1 text-center`}
			>
				<EyeChecklistBrowserPlane />
				<Text size="paragraph-2" weight="semi-bold">
					All employees with a link have access to the survey
				</Text>
			</div>
		</>
	);
};
